import { createReducer, on } from '@ngrx/store';

import * as AuthActions from '../actions/auth.actions';

export const featureKey = 'auth';

/**
 * @ngrx/entity provides a predefined interface for handling
 * a structured dictionary of records. This interface
 * includes an array of ids, and a dictionary of the provided
 * model type by id. This interface is extended to include
 * any additional interface properties.
 */
export interface State {
  loading: boolean;
  error: string;
  token: string;
  user: any;
}

/**
 * getInitialState returns the default initial state
 * for the generated entity state. Initial state
 * additional properties can also be defined.
 */
export const initialState: State = {
  loading: true,
  error: null,
  token: null,
  user: null
};

export const reducer = createReducer(
  initialState,
  on(AuthActions.meRetrieve, (state, { token}) => ({...state, loading: true, token})),
  on(AuthActions.meSuccess, (state, { user }) => ({...state, loading: false, error: null, user})),
  on(AuthActions.meFailure, (state, { error }) => ({...state, error, user: null})),
  on(AuthActions.accountSuccess, (state, { account }) => ({...state, error: null, user: {...state.user, ...account}})),
  on(AuthActions.accountFailure, (state, { error }) => ({...state, error})),
  on(AuthActions.updateUser, (state, { user }) => ({...state, user: { ...state.user, ...user }})),
  on(AuthActions.clear, (state) => ({loading: true, error: null, token: null, user: null}))
);
